// extracted by mini-css-extract-plugin
export default {"popup":"ModalPortfolio_popup__9FqL6","box_close_icon":"ModalPortfolio_box_close_icon__iE9QV","close_icon":"ModalPortfolio_close_icon__36LM0"};